import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { Button } from 'semantic-ui-react';

import '../css/CoTeacherAccessCode.less';

import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';
import PopupService from '../services/PopupService';
import UtilityService from '../services/UtilityService';

export default
@inject('classroomManager')
@observer
class CoTeacherAccessCode extends Component {
  constructor(props) {
    super(props);
    this.InfoIcon = SatCoreComponent('InfoIcon');
  }

  handleClickRefreshCode = (e) => {
    const { classroomManager, classId } = this.props;
    e.preventDefault();
    classroomManager.refreshCoTeacherAccessCode(classId);
    // eslint-disable-next-line react/destructuring-assignment
    this.props.onClick?.();
  }

  render() {
    const { classId, classroomManager, t, useWhiteInfoIcon } = this.props;

    const { InfoIcon } = this;

    let { code } = this.props;
    if (!code && classId && classId !== '') {
      code = classroomManager.getCoTeacherAccessCode(classId);
    }

    const tooltipAccessCode = t('tooltipAccessCode', '') || t('tooltipCoTeacherAccessCode', '');
    const parsedTooltipAccessCode = tooltipAccessCode
      ? UtilityService.reactHtmlParserWrapper(tooltipAccessCode).parsed
      : '';
    const refreshCoTeacherAccessCodeInfo = t('refreshCoTeacherAccessCodeInfo', '');

    return (
      <div className='coTeacherAccessCode'>
        <div className='accessCodeHeader'>
          {t('coTeacherAccessCode', 'Co-Teacher Access Code')}
          {!!tooltipAccessCode && (
            <InfoIcon className='InfoIcon-tooltipCoTeacherAccessCode InfoIcon-tooltip-default'
              popupOptions={{ content: parsedTooltipAccessCode, on: 'hover' }}
              useWhiteInfoIcon={useWhiteInfoIcon} />
          )}
        </div>
        <div className='accessCode'>
          <div className='accessCodeLabel'>{code}</div>
          <div className='accessCodeRefresh'>
            {PopupService.renderPopup({
              content: refreshCoTeacherAccessCodeInfo,
              disabled: !refreshCoTeacherAccessCodeInfo,
              trigger: (
                <Button basic onClick={this.handleClickRefreshCode}
                  size='mini' type='button'>
                  {t('refresh', 'Refresh')}
                </Button>
              ),
              wide: false
            })}
          </div>
        </div>
      </div>
    );
  }
}

SatCoreRegister('CoTeacherAccessCode', CoTeacherAccessCode);
